import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchModules } from "../api/modules";
import Loader from "../components/Loader";
import { ClipboardList, Plus, Upload } from "lucide-react";

function ManagementFramework() {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadModules = async () => {
      try {
        const data = await fetchModules();
        setModules(data);
      } catch (error) {
        console.error("Error fetching modules:", error);
      } finally {
        setLoading(false);
      }
    };

    loadModules();
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Header Section */}
      <header className="flex items-center justify-between mb-6">
        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-800">Management Framework</h1>

        {/* Action Buttons */}
        {/*<div className="flex gap-4">
          <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md shadow hover:bg-blue-700 transition">
            <Plus className="w-4 h-4" />
            Add Module
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded-md shadow hover:bg-gray-300 transition">
            <Upload className="w-4 h-4" />
            Upload
          </button>
        </div> */}
      </header>

      {/* Module Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {modules.map((module) => (
          <div
            key={module.id}
            className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition-all cursor-pointer"
            onClick={() => navigate(module.route)}
          >
            {/* Icon */}
            <div className="flex justify-center items-center bg-blue-100 w-16 h-16 rounded-full mx-auto mb-4">
              <ClipboardList className="w-8 h-8 text-blue-600" />
            </div>

            {/* Title */}
            <h3 className="text-lg font-semibold text-center text-gray-800">{module.name}</h3>

            {/* Description */}
            <p className="text-gray-500 text-center text-sm mt-2">{module.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManagementFramework;